import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		position: null,
		hasSubmitted: false,

		steps: [{
			name: 'Personal',
			url: '/personal',
			complete: false,
		}, {
			name: 'Questionnaire',
			url: '/questionnaire',
			complete: false,
		}, {
			name: 'Experience',
			url: '/experience',
			complete: false,
		}, {
			name: 'Review',
			url: '/review',
			complete: false,
		}],

		form: {
			personal: {
				first: '',
				middle: '',
				last: '',
				address1: '',
				address2: '',
				city: '',
				state: '',
				zip: '',
				email: '',
				phone: '',
			},

			questionnaire: {
				legally: '',
				nights: '',
			},

			experience: {
				education: [],
				employment: [],
			},
		}
	},

	mutations: {
		initialize(state) {
			if (localStorage.getItem('position')) {
				state.position = localStorage.getItem('position')
			}
		},

		setPosition(state, position) {
			state.position = position

			localStorage.setItem('position', state.position)
		},

		setPersonal(state, { first, middle, last, address1, address2, city, state: newState, zip, email, phone }) {
			state.form.personal.first = first
			state.form.personal.middle = middle
			state.form.personal.last = last
			state.form.personal.address1 = address1
			state.form.personal.address2 = address2
			state.form.personal.city = city
			state.form.personal.state = newState
			state.form.personal.zip = zip
			state.form.personal.email = email
			state.form.personal.phone = phone

			state.steps[0].complete = true
		},

		setQuestionnaire(state, { legally, nights }) {
			state.form.questionnaire.legally = legally
			state.form.questionnaire.nights = nights

			state.steps[1].complete = true
		},

		setExperience(state, { education, employment }) {
			state.form.experience.education = education
			state.form.experience.employment = employment

			state.steps[2].complete = true
		},

		submit(state) {
			state.hasSubmitted = true
		},
	},

	actions: {

	}
})
